module.exports = __webpack_public_path__ + "img/poly-7.d3d05d09.png";